import { MODERATOR_ABOUT_TEAM } from "../mock/URLs"
import { ITeamMember, ITeamMemberById } from "../types/team"
import { api } from "./api"

export const getTeamMembers = async () => {
    try {
        const { data } = await api.get<{data: ITeamMember[]}>(MODERATOR_ABOUT_TEAM)
        return data.data
    }
    catch (e) {
        console.log(e)
    }
}

export const getTeamMemberById = async (id:number) => {
    try {
        const { data } = await api.get<{data: ITeamMemberById}>(`${MODERATOR_ABOUT_TEAM}${id}/`)
        return data.data
    }
    catch (e) {
        console.log(e)
    }
}


export const createTeamMember = async (values: FormData) => {
    try {
        const { data } = await api.post(MODERATOR_ABOUT_TEAM, values);
        return data.data
    } catch (e) {
        throw e
    }
}

export const updateTeamMember = async (id, values: FormData)=>{
    try {
        const { data } = await api.patch(`${MODERATOR_ABOUT_TEAM}${id}/`, values);
        return data
    } catch (e) {
        throw e
    }
}